"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgHeartRateFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M12 20.994c-.26 0-.591-.123-.996-.369-1.027-.552-6.365-4.442-7.793-7.178h3.4l2.48 2.243c.287.235.567.34.84.313.273-.027.508-.183.703-.466l1.583-3.503 1.834 2.628c.168.2.365.313.591.338a.988.988 0 00.615-.12l2.103-1.44h3.43c-1.423 2.75-6.857 6.566-7.792 7.185-.405.246-.738.37-.997.37L12 20.994zm7.424-9.533l-2.041-.008c-.328 0-.56.022-.696.068-.136.045-.302.145-.497.3l-1.1.767-2.155-3.008c-.217-.387-.53-.582-.935-.585-.407-.004-.7.191-.883.585l-1.665 3.744-1.68-1.546a1.276 1.276 0 00-.378-.257c-.103-.038-.276-.06-.519-.069H2.391A7.83 7.83 0 012 8.995C2 5.627 4.42 3 7.5 3c1.74 0 3.41.883 4.5 2.267C13.09 3.883 14.76 3 16.5 3 19.58 3 22 5.627 22 8.995c0 .82-.135 1.634-.393 2.466h-2.183z' }))); };
exports.default = SvgHeartRateFilled;
//# sourceMappingURL=HeartRateFilled.js.map